import type { GatewayPrincipalUsageSummaryView } from '@/types';

export interface UsageChartRow {
  date: string;
  costUsd: number;
  totalTokens: number;
  requestCount: number;
}

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const integerFormatter = new Intl.NumberFormat('en-US');

export function buildUsageChartRows(
  summary: GatewayPrincipalUsageSummaryView | null,
): UsageChartRow[] {
  if (!summary) {
    return [];
  }
  return summary.daily.map((item) => ({
    date: item.usageDate,
    costUsd: item.costUsd,
    totalTokens: item.totalTokens,
    requestCount: item.requestCount,
  }));
}

export function formatUsageCost(value: number) {
  return usdFormatter.format(value || 0);
}

export function formatUsageInteger(value: number) {
  return integerFormatter.format(value || 0);
}
